import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Kudos Category Service */
const addKudosCategory = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.addKudosCategory}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Kudos Category Service */
const getKudosCategory = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.getKudosCategory}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Create Kudos Service*/
const createKudos = (params) => {
    const { axiosInstance, config, source } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.createKudos}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};



/* Get Kudos Service */
const getKudosData = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.getKudosData}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Add Kudos Point History Service */
const addKudosPointHistory = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.addKudosPointHistory}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Point Statement Service */
const getPointStatement = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.getPointStatement}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get User Kudos On Type */
const getUserKudosOnType = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.getUserKudosOnType}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Get User Kudos On Type */
const approveRejectKudos = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.kudos.approveRejectKudos}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};
export default {
    addKudosCategory,
    getKudosCategory,
    createKudos,
    getKudosData,
    addKudosPointHistory,
    getPointStatement,
    getUserKudosOnType,
    approveRejectKudos
}